/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import CatalogDefinitions from './catalog-definitions';
import CatalogDefinitionsDetail from './catalog-definitions-detail';
import CatalogDefinitionsUpdate from './catalog-definitions-update';
import CatalogDefinitionsDeleteDialog from './catalog-definitions-delete-dialog';

const CatalogDefinitionsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<CatalogDefinitions />} />
    <Route path="new" element={<CatalogDefinitionsUpdate />} />
    <Route path=":id">
      <Route index element={<CatalogDefinitionsDetail />} />
      <Route path="edit" element={<CatalogDefinitionsUpdate />} />
      <Route path="delete" element={<CatalogDefinitionsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default CatalogDefinitionsRoutes;
